import { render, staticRenderFns } from "./ExpectedDeliveryWidget.vue?vue&type=template&id=0808ef16&"
import script from "./ExpectedDeliveryWidget.vue?vue&type=script&lang=js&"
export * from "./ExpectedDeliveryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QSelect,QSeparator,QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QSelect,QSeparator,QTable,QTr,QTh,QTd})
